import "./About.module.css";
import Header from "@/reusable_sections/Header";
import OurStory from "./sections/OurStory";
import Gallery from "./sections/Gallery";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <OurStory />
      <Gallery />
      <Footer />
    </div>;
}